package org.lennycodes.gradematewebsite

import com.varabyte.kobweb.compose.ui.graphics.Color

fun hexToColor(hex: String): Color {
    val clean = hex.trimStart('#')
    return try {
        val r = clean.substring(0, 2).toInt(16)
        val g = clean.substring(2, 4).toInt(16)
        val b = clean.substring(4, 6).toInt(16)
        Color.rgb(r, g, b)
    } catch (e: Throwable) {
        Color.rgb(99, 102, 241) // indigo fallback
    }
}

/** Convert a Kobweb Color into a "#RRGGBB" hex string. Returns null on failure. */
fun Color.toHexOrNull(): String? {
    return try {
        val rgb = this as Color.Rgb
        val r = rgb.red.toString(16).padStart(2, '0')
        val g = rgb.green.toString(16).padStart(2, '0')
        val b = rgb.blue.toString(16).padStart(2, '0')
        "#$r$g$b".uppercase()
    } catch (e: Throwable) {
        null
    }
}
fun Color.withAlpha(alpha: Float): Color {
    val rgb = this as Color.Rgb
    return Color.rgba(rgb.red, rgb.green, rgb.blue, alpha)
}